<template>
	<a href="javascript:;" @click="handleFullscreen">
		<t-icon class="t-menu__operations-icon" :name="isFullscreen ? 'fullscreen-exit' : 'fullscreen-1'" />
	</a>
</template>

<script setup lang="ts">
import { ref } from 'vue'

// 是否全屏
const isFullscreen = ref(false)
// 切换全屏
const handleFullscreen = () => {
	if (isFullscreen.value) {
		document.exitFullscreen()
	} else {
		document.documentElement.requestFullscreen()
	}
	isFullscreen.value = !isFullscreen.value
}
</script>

<style scoped></style>
